export default __webpack_public_path__ + "images/db-logos/google_analytics4.png";